import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SelectableCampaignTerm } from '../../../../models/selectable-campaign-term';
import { TermBindingModel, TermParamType, TermParam } from '../../../../models/campaign-save';

@Component({
  selector: 'selectable-campaign-terms',
  templateUrl: './selectable-campaign-terms.component.html',
  styleUrls: ['./selectable-campaign-terms.component.scss']
})
export class SelectableCampaignTermsComponent {
  @Input()
  selectableCampaignTerms: SelectableCampaignTerm[];

  @Input()
  isReadOnly: boolean;

  @Output()
  selectedChange = new EventEmitter<any>();

  @Output()
  deleteTermEvent = new EventEmitter<any>();

  @Output()
  modifyCustomTermEvent = new EventEmitter<any>();

  onModelChanged(value) {
    console.log(value);
  }

  selectChange(e) {
    this.selectedChange.emit(this);
  }

  deleteTerm(e) {
    this.deleteTermEvent.emit(e);
  }

  modifyCustomTerm(term) {
    this.modifyCustomTermEvent.emit(term);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/campaigns-add/selectable-campaign-terms/selectable-campaign-terms.component.ts